// Pricing data for all Instant Iris products
// All prices in NOK

export const products = {
  digital: {
    id: "digital",
    name: "Digital Fil",
    description:
      "Alle produkter kommer med denne digitale filen inkludert gratis. Få ditt unike bilde tilsendt på e-post som en digital fil. Priser under er ved kjøp av kun digital fil. Bruk det som bakgrunnsbilde på mobil, klokke eller som profilbilde på sosiale medier. Mulighetene er mange!",
    attributes: ["Velg blant mange gratis effekter"],
    type: "digital",
    maxIris: 5,
    // Digital has flat pricing per iris count
    irisPricing: {
      1: 799,
      2: 1199,
      3: 1499,
      4: 1999,
      5: 2399,
    },
  },

  paper: {
    id: "paper",
    name: "Profesjonelt Fotopapir",
    description:
      "På bare noen minutter blir bildene dine skrevet ut på glanset fotopapir av høy kvalitet. Fullfør utseendet med våre profesjonelle innrammingsalternativer i butikken. Rask, elegant og laget for å vare.",
    attributes: ["Velg blant mange gratis effekter"],
    type: "paper",
    maxIris: 5,
    sizes: [
      { id: "20x20", label: "20 x 20cm", price: 599 },
      { id: "30x30", label: "30 x 30cm", price: 799 },
      { id: "40x40", label: "40 x 40cm", price: 999 },
    ],
    // Additional iris cost (first iris included)
    additionalIrisPrice: 499,
    // Frame options by size
    frames: [
      { id: "20x20", label: "20 x 20cm", price: 189 },
      { id: "30x30", label: "30 x 30cm", price: 269 },
      { id: "40x40", label: "40 x 40cm", price: 349 },
    ],
  },

  a2: {
    id: "a2",
    name: "A2 Print",
    description:
      "Stort A2-format på glanset fotopapir av høy kvalitet. Perfekt når du vil ha mer veggkraft. Velg valgfri ramme i akryl eller glass for et ferdig uttrykk.",
    attributes: ["A2-format", "Velg blant mange gratis effekter"],
    type: "paperA2",
    maxIris: 5,
    price: 1299,
    label: "A2",
    additionalIrisPrice: 499,
    frames: [
      { id: "acrylic", label: "Akrylramme", price: 499 },
      { id: "glass", label: "Glassramme", price: 799 },
    ],
  },

  acrylicSquare: {
    id: "acrylicSquare",
    name: "Akryl 5mm - Kvadrat og Rektangel",
    description:
      "Utforsk våre 5mm hardbelagte akryltrykk, der moderne design møter uovertruffen holdbarhet. Forsterk kunsten din med vår glansfulle akryloverflate, spesiallaget for å tilføre et ekstra lag med dybde til bildene dine. I tillegg, med vår HC hardbelegg, kan du enkelt tørke av trykket med en klut, alt uten å kompromittere dets integritet. Opplev kunst i en ny dimensjon.",
    attributes: [
      "Water resistant",
      "UV resistant",
      "Scratch resistant",
      "Velg blant mange gratis effekter",
    ],
    type: "sizeWithIrisTiers",
    maxIris: 5,
    shapes: [
      {
        id: "square",
        label: "Kvadrat",
        sizes: [
          { id: "40x40", label: "40 x 40cm", price: 3999 },
          { id: "50x50", label: "50 x 50cm", price: 4999 },
          { id: "60x60", label: "60 x 60cm", price: 6499 },
          { id: "80x80", label: "80 x 80cm", price: 11999 },
          { id: "100x100", label: "100 x 100cm", price: 16999 },
          { id: "120x120", label: "120 x 120cm", price: 19999 },
        ],
      },
      {
        id: "rectangle",
        label: "Rektangel",
        note: "Anbefalt for 5+ iris",
        sizes: [
          { id: "40x60", label: "40 x 60cm", price: 6999 },
          { id: "60x90", label: "60 x 90cm", price: 9999 },
          { id: "80x120", label: "80 x 120cm", price: 14999 },
          { id: "100x150", label: "100 x 150cm", price: 24999 },
          { id: "120x180", label: "120 x 180cm", price: 36999 },
        ],
      },
    ],
    // Tiered iris pricing
    irisTiers: {
      1: 0,
      2: 300,
      3: 600,
      4: 800,
      5: 1000,
    },
  },

  acrylicLine: {
    id: "acrylicLine",
    name: "Akryl Line",
    description:
      "Møt våre linjeformede akrylmalerier, designet for å fremheve flere øyne på rad. Disse kunstverkene er laget av det samme høykvalitets akrylmaterialet som våre andre akrylprodukter, og gir dermed den samme uovertrufne holdbarheten og glansen. Opplev kunst i en ny, lineær dimensjon.",
    attributes: [
      "Water resistant",
      "UV resistant",
      "Scratch resistant",
      "Velg blant mange gratis effekter",
    ],
    type: "lineMatrix",
    minIris: 2,
    maxIris: 5,
    // Line products have combined iris+size pricing
    matrix: {
      2: [
        { id: "20x40", label: "20 x 40cm", price: 3699 },
        { id: "30x60", label: "30 x 60cm", price: 5299 },
        { id: "40x80", label: "40 x 80cm", price: 6999 },
      ],
      3: [
        { id: "20x60", label: "20 x 60cm", price: 4799 },
        { id: "30x90", label: "30 x 90cm", price: 6999 },
        { id: "40x120", label: "40 x 120cm", price: 14699 },
      ],
      4: [
        { id: "20x80", label: "20 x 80cm", price: 4999 },
        { id: "30x120", label: "30 x 120cm", price: 7999 },
        { id: "40x160", label: "40 x 160cm", price: 18999 },
      ],
      5: [
        { id: "20x100", label: "20 x 100cm", price: 7499 },
        { id: "30x150", label: "30 x 150cm", price: 19599 },
        { id: "40x200", label: "40 x 200cm", price: 24999 },
      ],
    },
  },

  acrylicCircle: {
    id: "acrylicCircle",
    name: "Akryl Sirkel",
    description:
      "Utforsk den unike sjarmen av våre sirkulære akrylmalerier, formet i likhet med en iris. Disse kunstverkene er laget av det samme høykvalitets akrylmaterialet som våre andre akrylprodukter, og gir dermed den samme uovertrufne holdbarheten og glansen. Opplev kunst i en ny, sirkulær dimensjon som speiler naturens egen perfeksjon.",
    attributes: [
      "Water resistant",
      "UV resistant",
      "Scratch resistant",
      "Velg blant mange gratis effekter",
    ],
    type: "sizeWithIrisTiers",
    maxIris: 2,
    shapes: [
      {
        id: "circle",
        label: "Sirkel",
        sizes: [
          { id: "40x40", label: "40 x 40cm", price: 3999 },
          { id: "50x50", label: "50 x 50cm", price: 4999 },
          { id: "60x60", label: "60 x 60cm", price: 6499 },
          { id: "80x80", label: "80 x 80cm", price: 12399 },
          { id: "100x100", label: "100 x 100cm", price: 17999 },
        ],
      },
    ],
    irisTiers: {
      1: 0,
      2: 300,
    },
  },

  aluSquare: {
    id: "aluSquare",
    name: "Aluminium 3mm - Kvadrat og Rektangel",
    description:
      "Oppdag den moderne elegansen til våre 3mm aluminiumstrykk. Med aluminium overflate og svart PVC kjerne er de lette og enkle å henge opp, og kan henge trygt både inne og ute. Den matte overflaten gir et moderne utseende, og gjør at bildet ditt kan skinne gjennom. Opplev kunst i en ny dimensjon.",
    attributes: [
      "Water resistant",
      "UV resistant",
      "Velg blant mange gratis effekter",
    ],
    type: "sizeWithIrisTiers",
    maxIris: 5,
    shapes: [
      {
        id: "square",
        label: "Kvadrat",
        sizes: [
          { id: "40x40", label: "40 x 40cm", price: 2599 },
          { id: "50x50", label: "50 x 50cm", price: 3299 },
          { id: "60x60", label: "60 x 60cm", price: 4499 },
          { id: "80x80", label: "80 x 80cm", price: 7799 },
          { id: "100x100", label: "100 x 100cm", price: 11299 },
          { id: "120x120", label: "120 x 120cm", price: 12999 },
        ],
      },
      {
        id: "rectangle",
        label: "Rektangel",
        note: "Anbefalt for 5+ iris",
        sizes: [
          { id: "40x60", label: "40 x 60cm", price: 4799 },
          { id: "60x90", label: "60 x 90cm", price: 6499 },
          { id: "80x120", label: "80 x 120cm", price: 9999 },
          { id: "100x150", label: "100 x 150cm", price: 16999 },
          { id: "120x180", label: "120 x 180cm", price: 24249 },
        ],
      },
    ],
    irisTiers: {
      1: 0,
      2: 300,
      3: 600,
      4: 800,
      5: 1000,
    },
  },

  aluLine: {
    id: "aluLine",
    name: "Aluminium Line",
    description:
      "Møt våre linjeformede 3mm aluminiumstrykk, designet for å fremheve flere øyne på rad. Disse kunstverkene er laget av det samme høykvalitets aluminiumsmaterialet som våre andre aluminiumprodukter, og gir dermed den samme uovertrufne holdbarheten med en stilig matt overflate. Opplev kunst i en ny, lineær dimensjon.",
    attributes: [
      "Water resistant",
      "UV resistant",
      "Velg blant mange gratis effekter",
    ],
    type: "lineMatrix",
    minIris: 2,
    maxIris: 5,
    matrix: {
      2: [
        { id: "20x40", label: "20 x 40cm", price: 2599 },
        { id: "30x60", label: "30 x 60cm", price: 3449 },
        { id: "40x80", label: "40 x 80cm", price: 4699 },
      ],
      3: [
        { id: "20x60", label: "20 x 60cm", price: 3399 },
        { id: "30x90", label: "30 x 90cm", price: 5299 },
        { id: "40x120", label: "40 x 120cm", price: 9699 },
      ],
      4: [
        { id: "20x80", label: "20 x 80cm", price: 3249 },
        { id: "30x120", label: "30 x 120cm", price: 5199 },
        { id: "40x160", label: "40 x 160cm", price: 12999 },
      ],
      5: [
        { id: "20x100", label: "20 x 100cm", price: 4899 },
        { id: "30x150", label: "30 x 150cm", price: 12799 },
        { id: "40x200", label: "40 x 200cm", price: 16499 },
      ],
    },
  },

  aluCircle: {
    id: "aluCircle",
    name: "Aluminium Sirkel",
    description:
      "Utforsk våre sirkulære aluminiumstrykk, formet i likhet med en iris. Disse kunstverkene er laget av det samme høykvalitets aluminiumsmaterialet som våre andre aluminiumsprodukter, og gir dermed den samme uovertrufne holdbarheten med en stilig matt overflate. Opplev kunst i en ny, sirkulær dimensjon som speiler naturens egen perfeksjon.",
    attributes: [
      "Water resistant",
      "UV resistant",
      "Velg blant mange gratis effekter",
    ],
    type: "sizeWithIrisTiers",
    maxIris: 2,
    shapes: [
      {
        id: "circle",
        label: "Sirkel",
        sizes: [
          { id: "40x40", label: "40 x 40cm", price: 2599 },
          { id: "50x50", label: "50 x 50cm", price: 3299 },
          { id: "60x60", label: "60 x 60cm", price: 4499 },
          { id: "80x80", label: "80 x 80cm", price: 7799 },
          { id: "100x100", label: "100 x 100cm", price: 11299 },
        ],
      },
    ],
    irisTiers: {
      1: 0,
      2: 300,
    },
  },
};

// Product order for display
export const productOrder = [
  "digital",
  "paper",
  "a2",
  "acrylicSquare",
  "acrylicLine",
  "acrylicCircle",
  "aluSquare",
  "aluLine",
  "aluCircle",
];

// Product images mapping
export const productImages = {
  digital: "digital-file1.webp",
  paper: "shelf.webp",
  a2: "a2.webp",
  acrylicSquare: "square.webp",
  acrylicLine: "lineweb.webp",
  acrylicCircle: "circle.webp",
  aluSquare: "square.webp",
  aluLine: "lineweb.webp",
  aluCircle: "circle.webp",
};

// Helper function to calculate price
export function calculatePrice(productId, options) {
  const product = products[productId];
  if (!product) return 0;

  const {
    irisCount = 1,
    sizeId,
    shapeId,
    includeFrame = false,
    frameId,
  } = options;

  switch (product.type) {
    case "digital":
      return product.irisPricing[irisCount] || 0;

    case "paper": {
      const size = product.sizes.find((s) => s.id === sizeId);
      if (!size) return 0;
      const basePrice = size.price;
      const irisPrice = (irisCount - 1) * product.additionalIrisPrice;
      const framePrice = includeFrame
        ? product.frames.find((f) => f.id === sizeId)?.price || 0
        : 0;
      return basePrice + irisPrice + framePrice;
    }

    case "paperA2": {
      const irisPrice = (irisCount - 1) * product.additionalIrisPrice;
      const framePrice =
        includeFrame && frameId
          ? product.frames.find((f) => f.id === frameId)?.price || 0
          : 0;
      return product.price + irisPrice + framePrice;
    }

    case "sizeWithIrisTiers": {
      const shape = product.shapes.find((s) => s.id === shapeId);
      if (!shape) return 0;
      const size = shape.sizes.find((s) => s.id === sizeId);
      if (!size) return 0;
      const irisPrice = product.irisTiers[irisCount] || 0;
      return size.price + irisPrice;
    }

    case "lineMatrix": {
      const sizes = product.matrix[irisCount];
      if (!sizes) return 0;
      const size = sizes.find((s) => s.id === sizeId);
      return size?.price || 0;
    }

    default:
      return 0;
  }
}

